import React from 'react';
import { ArrowRight, FileSpreadsheet, UploadCloud } from 'lucide-react';
import DataQualityPanel from '../components/analytics/DataQualityPanel';
import DataPreview from '../components/upload/DataPreview';
import Button from '../components/ui/Button';
import { getStoredDataset } from '../services/analytics';

const DataReviewPage: React.FC = () => {
  const dataset = getStoredDataset();

  if (!dataset) {
    return (
      <div className="page-stack" style={{ maxWidth: '900px' }}>
        <span className="icon-tile" style={{ width: '56px', height: '56px' }}><FileSpreadsheet size={28} /></span>
        <h1 style={{ fontSize: '2.35rem', marginBottom: '0.5rem' }}>No upload found</h1>
        <p>Upload a CSV or Excel file first so GabMic can detect columns and prepare analytics.</p>
        <Button variant="primary" onClick={() => window.location.assign('/upload')}><UploadCloud size={18} />Upload data</Button>
      </div>
    );
  }

  return (
    <div className="page-stack">
      <header className="page-header">
        <div>
          <h1 style={{ fontSize: '2.2rem', marginBottom: '0.55rem' }}>Review detected columns</h1>
          <p className="page-kicker">Confirm the columns GabMic detected. The analytics will adapt to these fields.</p>
          <span className="file-chip" style={{ marginTop: '1rem' }}>
            <FileSpreadsheet size={17} />
            {dataset.fileName}
          </span>
        </div>
      </header>

      <DataPreview dataset={dataset} />

      <DataQualityPanel dataset={dataset} />

      <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
        <Button variant="outline" onClick={() => window.location.assign('/upload')}>
          <UploadCloud size={17} />
          Upload Different File
        </Button>
        <Button variant="primary" onClick={() => window.location.assign('/analytics')}>
          Approve & Analyze
          <ArrowRight size={17} />
        </Button>
      </div>
    </div>
  );
};

export default DataReviewPage;
